import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Router from '../Router/router';
import './App.scss';
import { ThemeProvider } from '../Context/ThemeContext';

function App() {
  const { i18n } = useTranslation();

 useEffect(() => {
  i18n.changeLanguage(localStorage.getItem('p_m_language') ?? 'hy');

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: "SET_LOCALE",
          locale: localStorage.getItem("p_m_language") || "hy",
        });
      }
    });
  }
}, [i18n]);

  return (
    <ThemeProvider>
    <Router/>
    </ThemeProvider>
  );
}

export default App;
